module.exports = __webpack_public_path__ + "static/media/image_290.b99862ea.png";